import React, { useEffect, useRef } from 'react';

const StopMap = ({ stop, routeColor = '#EAB308' }) => {
    const mapRef = useRef(null);
    const mapInstanceRef = useRef(null);

    useEffect(() => {
        if (!mapRef.current || !window.google || !stop) return;

        // Create or update map
        if (!mapInstanceRef.current) {
            mapInstanceRef.current = new window.google.maps.Map(mapRef.current, {
                center: { lat: stop.latitude, lng: stop.longitude },
                zoom: 17,
                disableDefaultUI: true,
                zoomControl: true,
                styles: [
                    {
                        featureType: "poi",
                        elementType: "labels",
                        stylers: [{ visibility: "off" }]
                    }
                ]
            });

            // Add Stop Marker (Red circle with white square inside - stop symbol)
            new window.google.maps.Marker({
                position: { lat: stop.latitude, lng: stop.longitude },
                map: mapInstanceRef.current,
                title: stop.name,
                icon: {
                    url: 'data:image/svg+xml,' + encodeURIComponent(`
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                            <circle cx="12" cy="12" r="10" fill="#EF4444" stroke="#FFFFFF" stroke-width="2"/>
                            <rect x="6" y="9" width="12" height="6" fill="#FFFFFF" rx="1"/>
                        </svg>
                    `),
                    scaledSize: new window.google.maps.Size(28, 28),
                    anchor: new window.google.maps.Point(14, 14)
                },
                zIndex: 1000
            });
        } else {
            // Recenter existing map
            mapInstanceRef.current.setCenter({ lat: stop.latitude, lng: stop.longitude });
        }
    }, [stop, routeColor]);

    return (
        <div
            ref={mapRef}
            style={{ width: '100%', height: '100%' }}
        />
    );
};

export default StopMap;
